import {
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue'
import checkIsImage from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/functions/checkIsImage'

function createCanvasPreview(size: number | string) {
  const canvas = document.createElement('canvas')
  const previewWidth = Number(size)
  const previewHeight = Number(size)

  canvas.width = previewWidth
  canvas.height = previewHeight

  return canvas
}

function createImagePreview({
  canvas,
  file,
}: {
  canvas: HTMLCanvasElement
  file: File
}) {
  return new Promise<string>(resolve => {
    const context = canvas.getContext('2d')
    const image = document.createElement('img')
    const src = URL.createObjectURL(file)

    image.addEventListener('load', () => {
      const { width, height } = image
      const imageRatio = width / height

      if (width > height) {
        const proportionalHeight = canvas.width / imageRatio
        const offsetY = (canvas.height - proportionalHeight) / 2

        context?.drawImage(image, 0, offsetY, canvas.width, proportionalHeight)
      } else {
        const proportionalWidth = canvas.height * imageRatio
        const offsetX = (canvas.width - proportionalWidth) / 2

        context?.drawImage(image, offsetX, 0, proportionalWidth, canvas.height)
      }

      resolve(canvas.toDataURL())
      URL.revokeObjectURL(src)
    }, { once: true })

    image.src = src
  })
}

export default function usePreviewSrc({
  file,
  size,
}: {
  file: File
  size: number | string
}) {
  const previewSrc = ref('')
  const isImage = checkIsImage(file)

  onMounted(async () => {
    const canvas = createCanvasPreview(size)

    // Ставим прозрачный фон пока создаётся превью
    previewSrc.value = canvas.toDataURL()

    if (isImage) {
      previewSrc.value = await createImagePreview({ canvas, file })
    }
  })

  onBeforeUnmount(() => {
    URL.revokeObjectURL(previewSrc.value)
  })

  return {
    previewSrc,
  }
}
